import React, { useEffect, useState } from 'react';

import './imageFooted.scss';

interface ImageFootedProps {
    src?: string;
    children?: React.ReactNode;
    explanation: string;
    ignoreWidthAdjust?: boolean;
}

const ImageFooted: React.FC<ImageFootedProps> = ({ explanation, children, ignoreWidthAdjust = false }) => {
    const imageRef = React.createRef<HTMLDivElement>();
    const [pWidth, setPwidth] = useState('100%');

    useEffect(() => {
        setTimeout(() => {
            if (!ignoreWidthAdjust) {
                const width = imageRef.current?.getBoundingClientRect().width;
                setPwidth(`${width}px`);
            }
        }, 20)
    }, [])

    return (
        <div className="__ImageFooted" ref={imageRef}>
            <div className="_reference" style={{ maxWidth: pWidth }}>
                {children}
            </div>
            <p className="explain">
                {explanation.split('\n').map((s, i) => (
                    <React.Fragment key={i}>
                        <span>{s}</span>
                        <br />
                    </React.Fragment>
                ))}
            </p>
        </div>
    )
}

export default ImageFooted;